import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.scss',
})
export class RadioButtonComponent {
  active = input.required<boolean | undefined>();
  checked = model.required<boolean | undefined>();
  selectionGroupId = input.required<string>();
  user = input.required<any>();
  selectionChanged = output<any>();

  toggleSelection() {
    this.checked.set(true);
    this.selectionChanged.emit(this.user());
  }
}
